import React from 'react';
import PropTypes from 'prop-types';
import { ContentGrouping } from '../../core/ContentGrouping';
import { GeneralList } from '../../core/GeneralList';
import { API_RADIO_DOWNLOAD } from '../../../constants/api';

const RadioAudience = ({ dataList, title, defaultTextForNow }) => (
  <ContentGrouping titleWithBorder title={title}>
    <GeneralList
      dataList={dataList}
      defaultTextForNow={defaultTextForNow}
      apiGeneralList={API_RADIO_DOWNLOAD}
    />
  </ContentGrouping>
);

RadioAudience.propTypes = {
  dataList: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      href: PropTypes.string
    })
  ),
  title: PropTypes.string
};

export default RadioAudience;
